var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3200",
    "data-name": "Group 3200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213,
    height: 75,
    viewBox: "0 0 213 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.423,
    y1: 0.75,
    x2: 0.529,
    y2: 0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c5ff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 213,
    height: 75,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3199",
    "data-name": "Group 3199",
    transform: "translate(26.13 19.162)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download_on_Google_playstore",
    "data-name": "Download on Google playstore",
    transform: "translate(44.87 13.838)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Google playstore")), /*#__PURE__*/React.createElement("g", {
    id: "_x34_2.Google_PLay",
    transform: "translate(0 2.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M65.476,39.3l-5.413-3.127-5.542,5.542,5.542,5.542,5.432-3.137a2.814,2.814,0,0,0-.018-4.82Z",
    transform: "translate(-38.582 -25.717)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M30.569,27.2,15.474,12a2.849,2.849,0,0,0-.844,2.025V40.332a2.85,2.85,0,0,0,.844,2.025Z",
    transform: "translate(-14.63 -11.198)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M31.837,26l5.542-5.542.009-.009-7.426-4.275-9.789-5.753a2.777,2.777,0,0,0-2.851-.056,4.23,4.23,0,0,0-.581.431Z",
    transform: "translate(-15.898 -10)",
    fill: "#00f076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M16.742,65.2a4.231,4.231,0,0,0,.581.431,2.911,2.911,0,0,0,1.388.375,2.857,2.857,0,0,0,1.444-.412l9.807-5.725L37.388,55.6l-.009-.009-5.542-5.542Z",
    transform: "translate(-15.898 -34.045)",
    fill: "#f63448"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0899dacda9cd1993f6aeccc5e44c8b00.svg";
export { ForwardRef as ReactComponent };